export default __webpack_public_path__ + "8edfe59d267ad47fbed40e1710984375.svg";